export function checkLogin(html) {
    return new Promise((resolve) => {
        fetch("https://www.cedarparkchurchofchrist.org/admin")
            .then((res) => res.text())
            .then((htmlStr) => {
            if (htmlStr.indexOf("Please login to continue...") > -1) {
                html.innerHTML = `
                        <div class="attendance-data__login">
                            <p>You'll need to login to congregate first.</p>
                            <p><a href="/admin/login?r=/members/attendance-data">Login</a></p>
                        </div>`;
            }
            else {
                resolve();
            }
        });
    });
}
